<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">
          <span>学习培训详情</span>
        </div>
        <div class="searcharea">
          <label>时间筛选:</label>
          <input type="text"  class="form-control" v-validate="'required|date_format:yyyy-MM-dd|beforeDate:开始时间'" ref="beforeDateTarget" data-vv-scope="chooseDate" data-vv-as="开始时间" name="chooseStartDate" id="chooseStartDate" style="width: 120px;display: inline-block" v-model="studyStatisticsInfo.startDate" readonly>
          <!--<span class="validateTip">{{ errors.first('chooseDate.chooseStartDate') }}</span>-->
          &nbsp;&nbsp;—&nbsp;&nbsp;
          <input type="text" class="form-control" v-validate="'required|date_format:yyyy-MM-dd|afterDate:结束时间'" ref="afterDateTarget" data-vv-scope="chooseDate" data-vv-as="结束时间" name="chooseEndDate" id="chooseEndDate" style="width: 120px;display: inline-block" v-model="studyStatisticsInfo.endDate" readonly>
          <!--<span class="validateTip" style="padding-right: 70%">{{ errors.first('chooseDate.chooseEndDate') }}</span>-->
          <button type="button" class="btn btn-default btn_option" style="height: 28px;line-height: 15px" @click="initStudyStatisticsListData()">查询</button>

        </div>
      </div>
      <div class="body_content class_body_content">
        <div class="trainingStatisticsList_div">
          <table class="table table-striped table-bordered table_work">
            <thead>
            <tr>
              <th width="25%">姓名</th>
              <th width="25%">天数</th>
              <th width="25%">次数</th>
              <th width="15%">查看详情</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(studyStatisticsOne, index) in studyStatisticsList" :key="index">
              <td width="25%">{{studyStatisticsOne.teacherName}}</td>
              <td width="25%">{{studyStatisticsOne.dayNum}}</td>
              <td width="25%">{{studyStatisticsOne.num}}</td>
              <td width="15%">
                <div class="details_pic" data-toggle="modal" data-target="#myModal" @click="initDetailsList(studyStatisticsOne.teacherId,studyStatisticsOne.teacherName)"></div>
              </td>
            </tr>
            </tbody>
          </table>
          <!--详情-->
          <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">{{studyStatisticsInfo.teacherName}}</h4>
                </div>
                <div class="modal-body modal_work_details">
                  <table class="table table-bordered table-striped table_details">
                    <thead>
                    <tr>
                      <th width="30%">地点</th>
                      <th width="35%">内容</th>
                      <th width="20%">时间</th>
                      <th width="10%">天数</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(detailsOne, index) in detailsList" :key="index">
                      <td width="30%">{{detailsOne.addr}}</td>
                      <td width="35%">{{detailsOne.content}}</td>
                      <td width="20%">{{detailsOne.startDate}}—{{detailsOne.endDate}}</td>
                      <td width="10%">{{detailsOne.takeDay}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";
  import {getContentSize} from './mainView';
  import {Validator} from 'vee-validate';
  import WorkloadStatistics from '../components/workloadStatistics';

  export default {
    name: "studyTrainingDetailsStatistics",
    data() {
      return {
        //今日日期
        timeDate: '',
        //学习培训详情统计集合
        studyStatisticsList:[],

        //单个教师详情集合
        detailsList:[],

        current_teacherId:'',

        studyStatisticsInfo: {
          teacherId:'',
          teacherName:'',
          startDate:'',
          endDate:'',
        },

        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,
      }
    },
    components:{
      WorkloadStatistics
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //日期
        this_.dateDefault();
        // this_.loadValidator();

        this_.initStudyStatisticsListData();
      });
    },
    methods: {
      loadValidator(){
        let this_ = this;
        //日期之前验证
        const isBeforeDate = {
          validate: function (value, args) {
            let date1 = new Date(value);
            let obj = this_.$refs.afterDateTarget.value;
            if(obj){
              let data2 = new Date(obj);
              return date1.getTime() <= data2.getTime();
            }else {
              return true;
            }
          }
        }
        Validator.extend('beforeDate', isBeforeDate);
        //日期之后验证
        const isAfterDate = {
          validate: function (value, args) {
            let date1 = new Date(value);
            let obj = this_.$refs.beforeDateTarget.value;
            if(obj){
              let data2 = new Date(obj);
              return date1.getTime() >= data2.getTime();
            }else {
              return true;
            }
          }
        }
        Validator.extend('afterDate', isAfterDate);
      },
      /**
       * 学习培训详情统计列表
       */
      initStudyStatisticsListData(){
        let this_ = this;
        if(this_.userCode.indexOf(this_.leaderUserCode) != -1){
          schoolAxios({
            method: 'get',
            url: 'trainingLearn/classStatisticsListForLeader',
            params: {
              "startDate": this_.studyStatisticsInfo.startDate,
              "endDate": this_.studyStatisticsInfo.endDate
            }
          }).then(function (resp) {
            if(resp.data.success){
              this_.studyStatisticsList = resp.data.list;
            }
          });
        }else {
          schoolAxios({
            method: 'get',
            url: 'trainingLearn/classStatisticsList',
            params: {
              "startDate": this_.studyStatisticsInfo.startDate,
              "endDate": this_.studyStatisticsInfo.endDate
            }
          }).then(function (resp) {
            if(resp.data.success){
              this_.studyStatisticsList = resp.data.list;
            }
          });
        }
      },

      /**
       * 加载单个培训人员所有培训记录
       */
      initDetailsList(teacherId,teacherName){
        let this_=this;
        if(this_.userCode.indexOf(this_.leaderUserCode) != -1) {
          schoolAxios({
            method: 'get',
            url: 'trainingLearn/getMsgByteacherId',
            params: {
              "teacherId": teacherId,
              "startDate": this_.studyStatisticsInfo.startDate,
              "endDate": this_.studyStatisticsInfo.endDate
            }
          }).then(function (response) {
            // console.info(response);
            let data = response.data;
            if (data.success) {
              this_.studyStatisticsInfo.teacherId = teacherId;
              this_.studyStatisticsInfo.teacherName = teacherName;
              this_.detailsList = data.list;
            }
          });
        }else  {
          schoolAxios({
            method: 'get',
            url: 'trainingLearn/getMsgByteacherIdCreatorId',
            params: {
              "teacherId": teacherId,
              "startDate": this_.studyStatisticsInfo.startDate,
              "endDate": this_.studyStatisticsInfo.endDate
            }
          }).then(function (response) {
            // console.info(response);
            let data = response.data;
            if (data.success) {
              this_.studyStatisticsInfo.teacherId = teacherId;
              this_.studyStatisticsInfo.teacherName = teacherName;
              this_.detailsList = data.list;
            }
          });
        }
      },

      /**
       * 初始化日期选择框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#chooseStartDate').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseStartDate").val();
          this_.studyStatisticsInfo.startDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
        $('#chooseEndDate').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseEndDate").val();
          this_.studyStatisticsInfo.endDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/studyTrainingDetailsStatistics.css";
  .searcharea{
    position: absolute;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/studyTrainingDetailsStatistics.vue